var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('preloader'),_c('navbar'),_c('main',[_c('div',[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{attrs:{"items":_vm.allItems}})],1)],1)]),_c('foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }